import { Image, Popover } from 'antd';
import React, { useState } from 'react';
import styles from './ImageList.module.scss';
import { ImageEdit, ImageSearch } from './asset';
import { GenerationInfoPanelInner } from '@shakkerai/pro-canvas/src/components/elements/image/info';

// 评论评分、分享图片
export const ImageDetail = React.memo(({ imgData }) => {
  const { url, genInfo, width, height } = imgData;
  const [visible, setVisible] = useState(false);

  const ImageItem = (props) => {
    const handlePreviewImage = () => {
      setVisible(true);
    };

    return (
      <li {...props} className={styles.imageList}>
        <div className={styles.tagWrapper}>
          <Image src={url} preview={false} />
        </div>
        <div className={styles.mask}>
          <div className={styles.maskTopHalf} />
          <div className={styles.maskHint}>
            <p
              onClick={() => {
                handlePreviewImage();
              }}
            >
              <img src={ImageSearch} />
            </p>
          </div>
          <div className={styles.buttonWrapper}>
            <Popover
              arrow={false}
              overlayStyle={{ width: '300px' }}
              overlayClassName={styles.prompEditPopover}
              content={
                <GenerationInfoPanelInner
                  image={imgData}
                  genInfo={genInfo}
                  withHeader={false}
                  withFooter={false}
                  withSourceImage={true}
                  withSendButtons={false}
                  imageWidth={width}
                  imageHeight={height}
                />
              }
            >
              <img className={styles.edit} src={ImageEdit} />
            </Popover>
            {/* <img onClick={() => onRemoveImageItem(index, args)} className={styles.iconClose} src={ImageDelete} /> */}
          </div>
          <div
            className={styles.pictureFooter}
            style={{
              display: genInfo?.prompt || genInfo?.negativePrompt ? 'none' : '',
            }}
          >
            <span>Missing image detail information</span>
          </div>
        </div>
      </li>
    );
  };

  return (
    <>
      <ImageItem />
      <Image.PreviewGroup
        preview={{
          visible,
          onVisibleChange: (vis) => setVisible(vis),
        }}
        items={url ? [url] : []}
      />
    </>
  );
});
